import React from 'react';
import {AiOutlineHeart} from 'react-icons/ai';
import {RxVideo} from 'react-icons/rx';
import {AiOutlineStar} from 'react-icons/ai';
import {AiFillStar} from 'react-icons/ai';
import '../styles/subject.css'

const Subject = () => {
  return (
    <div className='syllabus'>

        <div className='topic'>
            <h2>Syllabus</h2>
            <p> Each subject on the website contains  every topic as recommended by the Unified Tertiary Matriculation board and this covers topics to bes asked in external examinations like WAEC, JAMB and Post UTME.
Good luck to you and God bless you.</p>
        </div>
        <button>All</button>
        <div className='courses'>
            <h2>General Subjects</h2>

        

            <div className='card'>
            <div className='course'>
                <h3> Mathematics</h3>

                <div className='s_down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='s_down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
          </div>


          <div className='course'>
              
                <h3>English</h3>

                <div className='s_down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='s_down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
          </div>


          <div className='course'>
                
                <h3> Economics</h3>

                <div className='s_down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='s_down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
          </div>


          <div className='course'>
               
                <h3>Civic Education</h3>

                <div className='s_down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='s_down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
          </div>



          <div className='course'>
                
                <h3> Computer  </h3>

                <div className='s_down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>

                 </div>
             <hr></hr>
            <div className='s_down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
                </div>
          </div>


          <div className='courses'>

            <h2>Science Subject</h2>

            <div className='card'>
          <div className='course'>
                
                <h3> Chemisty</h3>

                <div className='s_down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='s_down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
          </div>
         


          <div className='course'>
               
                <h3> Physics</h3>

                <div className='s_down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='s_down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
          </div>


          <div className='course'>
              
                <h3>Biology</h3>

                <div className='s_down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='s_down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
          </div>


          <div className='course'>
               
                <h3>Geography</h3>

                <div className='s_down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='s_down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
          </div>
        

        <div className='course'>
               
                <h3>T. D</h3>

                <div className='s_down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='s_down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
          
        </div>


        <div className='course'>
               
               <h3>Agricultural </h3>

               <div className='s_down'>
            
            <span>
             <i><RxVideo/></i>
                <p>Subjects</p></span>
             <span>   <i> <AiOutlineHeart/></i>
                <p>200+ Students</p> </span>
                </div>
            <hr></hr>
           <div className='s_down'>
               <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
               <button>Read</button>
               </div>
         
         </div>

             <div className='course'>
               
               <h3>FurtherMath</h3>

               <div className='s_down'>
            
            <span>
             <i><RxVideo/></i>
                <p>Subjects</p></span>
             <span>   <i> <AiOutlineHeart/></i>
                <p>200+ Students</p> </span>
                </div>
            <hr></hr>
           <div className='s_down'>
               <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
               <button>Read</button>
               </div>
               </div>
       </div>
       </div>
        </div>

        
        <div className='courses'>
            <h2>Art Subjects</h2>
            <div className='card'>

            <div className='course'>
               
               <h3> Goverment</h3>

               <div className='s_down'>
            
            <span>
             <i><RxVideo/></i>
                <p>Subjects</p></span>
             <span>   <i> <AiOutlineHeart/></i>
                <p>200+ Students</p> </span>
                </div>
            <hr></hr>
           <div className='s_down'>
               <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
               <button>Read</button>
               </div>
         
       </div>


       <div className='course'>
               
               <h3>Literature</h3>

               <div className='s_down'>
            
            <span>
             <i><RxVideo/></i>
                <p>Subjects</p></span>
             <span>   <i> <AiOutlineHeart/></i>
                <p>200+ Students</p> </span>
                </div>
            <hr></hr>
           <div className='s_down'>
               <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
               <button>Read</button>
               </div>
         
       </div>


       <div className='course'>
               
               <h3>CRS/IRS</h3>

               <div className='s_down'>
            
            <span>
             <i><RxVideo/></i>
                <p>Subjects</p></span>
             <span>   <i> <AiOutlineHeart/></i>
                <p>200+ Students</p> </span>
                </div>
            <hr></hr>
           <div className='s_down'>
               <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
               <button>Read</button>
               </div>
         
       </div>


       <div className='course'>
               
               <h3>Yoruba</h3>

               <div className='s_down'>
            
            <span>
             <i><RxVideo/></i>
                <p>Subjects</p></span>
             <span>   <i> <AiOutlineHeart/></i>
                <p>200+ Students</p> </span>
                </div>
            <hr></hr>
           <div className='s_down'>
               <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
               <button>Read</button>
               </div>
         
       </div>







            </div>

        </div>



        <div className='courses'>
    
           <h2>  Commercial Subjects</h2>

         <div className='card'>
            <div className='course'>
               
               <h3>Commerce</h3>

               <div className='s_down'>
            
            <span>
             <i><RxVideo/></i>
                <p>Subjects</p></span>
             <span>   <i> <AiOutlineHeart/></i>
                <p>200+ Students</p> </span>
                </div>
            <hr></hr>
           <div className='s_down'>
               <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
               <button>Read</button>
               </div>
         
       </div>

       <div className='course'>
               
               <h3>Insurance</h3>

               <div className='s_down'>
            
            <span>
             <i><RxVideo/></i>
                <p>Subjects</p></span>
             <span>   <i> <AiOutlineHeart/></i>
                <p>200+ Students</p> </span>
                </div>
            <hr></hr>
           <div className='s_down'>
               <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
               <button>Read</button>
               </div>
         
       </div>

       <div className='course'>
               
               <h3>Accounting</h3>

               <div className='s_down'>
            
            <span>
             <i><RxVideo/></i>
                <p>Subjects</p></span>
             <span>   <i> <AiOutlineHeart/></i>
                <p>200+ Students</p> </span>
                </div>
            <hr></hr>
           <div className='s_down'>
               <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p> Reviews</p> </span>
               <button>Read</button>
               </div>
         
       </div>





         </div>
    
    
       </div>



    </div>
  )
}

export default Subject